import { Box } from '@mui/material';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { SectionTitle } from '@shared/components/SectionTitle';
import { colorTheme } from '@styles/muiTheme';
import { IDSProps } from '../interfaces';
import { revenueData, revenueDetailColumns } from '../constants';

export const DealSheetDetails = ({ data }: IDSProps) => {
  return (
    <Box>
      <SectionTitle
        title="Revenue Detail"
        variant="h2"
      />
      <PhoenixGrid
        autoHeight
        withHeader
        noButton
        canNotCopy
        disableColumnMenu
        hideFooter
        columns={revenueDetailColumns}
        rows={revenueData(data) || []}
        pageSize={revenueData(data).length}
		sx={{backgroundColor: colorTheme.palette.common.white}}
      />
    </Box>
  );
};
